const parseCamelCaseToKebabCase = (name) => {
    return name
        .split(/(?=[A-Z])/)
        .join("-")
        .toLowerCase();
};
export default parseCamelCaseToKebabCase;
